// import { mapState } from 'vuex';
import iconsInformationModal from '@/components/Icons_information_component.vue';

export default {
    name: 'menu_component',
    props: {
      title: String, 
    },
    components: {
      iconsInformationModal
    },
    data() {
      return {
        url:window.location.protocol+'//'+window.location.hostname+'/index.php/',
        dropdown_toggle_1 : false,
        dropdown_toggle_2 : false,
        showHelpModal:false,
        customer_search_value:'',
        menu_toggle:false,
        products_dropdown_toggle:false
      }
    },

    // computed: {
    //   ...mapState(['menu_toggle']),
    //   menu_toggle(){
    //         return this.$store.state.menu_toggle;
    //     }
    // },

    mounted(){
      this.menu_toggle =  this.$store.state.menu_toggle
      this.menu_active_icon();      
    },
    watch:{
        menu_toggle(){
            window.setTimeout( function(){
//                let side_bar_width = document.getElementById('sidebar').offsetWidth;
//                document.getElementById('topbar').style.setProperty('left',side_bar_width+'px');
            },100)  
        }
    },

    methods:{

      menu_active_icon(){

        var active_menu = document.getElementsByClassName('router-link-exact-active')[0].children[0].children;
        active_menu[0].hidden = true
        active_menu[1].className = "icon_div";
       
        if(document.getElementsByClassName('router-link-exact-active')[0].closest('.dropdown-container') != null){
          
          var active_menu1 = document.getElementsByClassName('router-link-exact-active')[0].closest('.dropdown-container').previousElementSibling.children;
          var active_item = document.getElementsByClassName('router-link-exact-active')[0].closest('.dropdown-container').previousElementSibling
          active_item.className += ' pink';
          active_menu1[0].hidden = true
          active_menu1[1].className = "icon_div"
        }
        
      },


      toggle_nav(){
        this.$store.commit('menu_toggle');
      },
      show_menu(status){
        this.$store.state.menu_toggle =status;
        this.menu_toggle = status
      },
      show_help_popup(){
        this.showHelpModal = !this.showHelpModal;
        var help_menu = document.getElementsByClassName('help_menu_item')[0].children;
        if(this.showHelpModal == true){
          help_menu[0].hidden = true;
          help_menu[1].hidden = false;
          help_menu[1].className = "icon_div";
          if(help_menu[2])
          help_menu[2].className = "pink";
        }else{
          help_menu[0].hidden = false;
          help_menu[1].hidden = true;
          if( help_menu[2])
          help_menu[2].className = "";
        }
      },

      closeHelpPopup() {
        this.showHelpModal = false;
        var help_nav = document.getElementsByClassName('help_menu_item')[0].children;
        help_nav[0].hidden = false;
        help_nav[1].hidden = true;
        if( help_nav[2])
        help_nav[2].className = "";
      },
      check_key(e){
        if (e.keyCode === 13) {
          this.search_customer();
        }
      },
      search_customer(){
        location.href = `${this.url}customers/search_my_customers?search=${this.customer_search_value}`;
      }

    },   
}